import React,{Component} from 'react';
import {createMarkup} from './Factory';
import Flexbox from '../components/misc/Flexbox'; 
import Membership from '../components/Membership'; 

class Freund extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  memberships:'',
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	handleOpen(){
		this.setState({
			memberships:'open',
		});
		document.body.classList.toggle('no-scroll');
	}
	handleClose(data){
		this.setState({
			memberships:''
		});
		document.body.classList.toggle('no-scroll');
	}
	render(){				
		const { 
			title_left,title_right,image_data,content,vorteile_title_left,vorteile_title_right,vorteile,
			mitgliedschaften_left,mitgliedschaften_right,mitgliedschaften_title,mitgliedschaften_subtitle,mitgliedschaften_price,
			vorstand_left,vorstand_right,vorstand,aktiviation_left,aktiviation_right,aktiviation
		} = this.props;
		let {image:imgUrl,title:image_title,alt,image_tiny} = image_data;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}
		const {label_member_button} = this.props.staticData;
		return(
				<div>
					<div className="lg-side-padding container-fluid current-exhibition">
						<Flexbox left={title_left} right={title_right} />
						<div title={image_title} className="featured-block" style={divStyle}>
							<img src={image_tiny} alt={alt} title={image_title} />
						</div>
					</div>
					<div className="container-fluid lg-side-padding">
						<div className="content-container">
							<div className="md-txt margin-top-50 margin-top-30-mobile" dangerouslySetInnerHTML={createMarkup(content.rendered)}></div>						
						
                            <section>
                                <Flexbox extra="h2 margin-top-50" left={vorteile_title_left} right={vorteile_title_right} />
                                <ul className="points-list md-txt margin-top-neg10-tablet">
                                    {
                                        vorteile.map( (data,i)=>(
                                            <li key={i}>{data}</li>
                                        ))
                                    }							
                                </ul>
                            </section>

                            <section className="memberships">
                                <Flexbox extra="h2 margin-top-50" left={mitgliedschaften_left} right={mitgliedschaften_right} />

                                <div className="mem-list margin-top-neg10-tablet">
                                {
                                    mitgliedschaften_title.map( (data,i) =>(
                                        <div className="mem-wrap md-txt" key={i}>
                                            <p className="mem-type">{data}</p>
                                            <span className="info">{mitgliedschaften_subtitle[i]}</span>
                                            <div className="price h2"><b>{mitgliedschaften_price[i]}</b></div>
                                        </div>
                                    ))
                                }
                                </div>

                                <a onClick={this.handleOpen} className="btn dark-btn margin-top-40 margin-top-20-tablet">{label_member_button}</a>
                            </section>
							<section>
								 <Flexbox extra="h2 margin-top-50" left={aktiviation_left} right={aktiviation_right} />
								 <div className="md-txt" dangerouslySetInnerHTML={createMarkup(aktiviation)}></div>
							</section>
                            <section className="board">
                                <Flexbox extra="h2 margin-top-50" left={vorstand_left} right={vorstand_right} />

                                <ul className="md-txt board-members">
                                {	
                                    vorstand.map( (data,i) => (
                                        <li key={i}>{data}</li>
                                    ))
                                }
                                </ul>
                            </section>
						</div>
					</div>
					<Membership {...this.props} handleClick={this.handleClose} staticData={this.props.staticData} status={this.state.memberships} />
				</div>
		)
	}
}
export default Freund;




// WEBPACK FOOTER //
// ./src/components/Freund.js